import { render } from "./CategoryTree2ImageSetting.vue?vue&type=template&id=47cf81ac&scoped=true"
import script from "./CategoryTree2ImageSetting.vue?vue&type=script&lang=js"
export * from "./CategoryTree2ImageSetting.vue?vue&type=script&lang=js"

import "./CategoryTree2ImageSetting.vue?vue&type=style&index=0&id=47cf81ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cf81ac"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/CategoryTree2ImageSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47cf81ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47cf81ac', __exports__)) {
    api.reload('47cf81ac', __exports__)
  }
  
  module.hot.accept("./CategoryTree2ImageSetting.vue?vue&type=template&id=47cf81ac&scoped=true", () => {
    api.rerender('47cf81ac', render)
  })

}


export default __exports__